module.exports = __webpack_public_path__ + "static/media/Illuminate.c796d85a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Illuminate.jpg
// module id = 1691
// module chunks = 0